// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : SANCTION REPORT
// MODIFIED DATE: 29-09-2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import sanctionReportTypes from './sanction-report.types';
import { getSanctionReportDetails } from './sanction-report.services';
import {
	getSanctionReportSuccess,
	getSanctionReportFailure,
	getSanctionReportResponseResetChanged,
} from './sanction-report.action';
import { encryptData } from '../../_common/enode-decode';

/** *********************  START GET SANCTION DETAILS  ******************** */
export function* getSanctionReport({ payload }: any) {
	try {
		const key = 'GetSanctionReportDetailsKey';
		const {
			companyID,
			databaseName,
			centerID,
			requestStartDate,
			requestEndDate,
			branchID,
			limit,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			FromDate: requestStartDate,
			ToDate: requestEndDate,
			BranchID: branchID,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getSanctionReportDetails, encodeData);
		if (responseData.data.statusCode === '101') {
			yield put(getSanctionReportFailure(responseData.data));
		} else {
			yield put(getSanctionReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSanctionReportFailure(error));
	}
}

export function* resetGetSanctionReportResponse() {
	yield put(getSanctionReportResponseResetChanged());
}

export function* onGetSanctionReportDetails() {
	yield takeLatest(sanctionReportTypes.GET_SANCTION_REPORT_START, getSanctionReport);
}

export function* onGetSanctionReportResponseReset() {
	yield takeLatest(
		sanctionReportTypes.GET_SANCTION_REPORT_RESPONSE_RESET_START,
		resetGetSanctionReportResponse,
	);
}
/** *********************  END GET SANCTION DETAILS ******************** */

export function* sanctionReportSaga() {
	yield all([call(onGetSanctionReportDetails), call(onGetSanctionReportResponseReset)]);
}
